export const SET_DENTAL_FILTER = "dental_quote_page/SET_DENTAL_FILTER";

export function setDentalFilter(field, rawValue) {
  return {
    type: SET_DENTAL_FILTER,
    field,
    rawValue,
    meta: {
      analytics: {
        type: "filter_used",
        properties: {
          label: `dental-${field}`,
          value: JSON.stringify(rawValue),
        },
      },
    },
  };
}

export const RESET_DENTAL_FILTER = "dental_quote_page/RESET_DENTAL_FILTER";

export function resetFilter() {
  return { type: RESET_DENTAL_FILTER };
}
